<template>
    <div class="d-flex flex-column">
        <h6 class="text-center mb-4">
            <router-link :to="{ path: '/portal/users' }">
                Users
            </router-link>
            / {{ async.loading ? '' : results.id || 'Not Found' }}
        </h6>
        <AsyncWrapper
            :data="results"
            :loading="async.loading"
            :error="async.error"
            :wrapperClass="'d-flex flex-column justify-content-center align-items-center'"
        >
            <template slot="dataComponent">
                <user-view :user="results"></user-view>
            </template>
            <template slot="loadingComponent">
                <i class="fa fa-circle-o-notch fa-2x fa-spin"></i>
            </template>
            <template slot="errorComponent">
                <p>{{ async.error }}</p>
            </template>
            <template slot="emptyComponent">
                <p>No user with that id was found</p>
            </template>
        </AsyncWrapper>
    </div>
</template>
<script>
import UserView from './UserView'
export default {
    components: {
        UserView
    },
    computed: {
        results() {
            return {
                ...this.$store.getters['users/GET_USER'],
                orders: this.$store.getters['userOrders/GET_USER_ORDERS'],
                addresses: this.$store.getters['userAddresses/GET_USER_ADDRESSES']
            }
        },
        async() {
            return {
                loading:
                    this.$store.getters['users/GET_ASYNC'].loading ||
                    this.$store.getters['userOrders/GET_ASYNC'].loading ||
                    this.$store.getters['userAddresses/GET_ASYNC'].loading,
                error:
                    this.$store.getters['users/GET_ASYNC'].error ||
                    this.$store.getters['userOrders/GET_ASYNC'].error ||
                    this.$store.getters['userAddresses/GET_ASYNC'].error
            }
        }
    },
    created() {
        this.$store.dispatch('users/FETCH_USER_BY_ID', {
            id: this.$route.params.id
        })
        this.$store.dispatch('userOrders/FETCH_USER_ORDERS_BY_ID', {
            id: this.$route.params.id,
            limit: 50
        })
        this.$store.dispatch('userAddresses/FETCH_USER_ADDRESSES_BY_ID', {
            id: this.$route.params.id
        })
    },
    beforeRouteLeave(to, from, next) {
        this.$store.dispatch('users/REMOVE_USER_REFERENCE', {
            id: this.$route.params.id
        })
        this.$store.dispatch('userOrders/REMOVE_USER_ORDERS_REFERENCE', {
            id: this.$route.params.id
        })
        this.$store.dispatch('userAddresses/REMOVE_USER_ADDRESSES_REFERENCE', {
            id: this.$route.params.id
        })
        next()
    }
}
</script>
